import React from 'react'
import {buildImageObj, getProjectUrl} from '../lib/helpers'
import {imageUrlFor} from '../lib/image-url'

import '../styles/project-preview.css'

function ProjectPreview (props) {

  //console.log(props);

  return (
    <>
      {props.image.desktopImage && props.image.desktopImage.asset && props.image.mobileImage && props.image.mobileImage.asset && (
          <div className="project-preview-item">
          <a title={props.image.desktopImage.alt} href={getProjectUrl(props.publishedAt, props.slug.current)}>
          <div class="info">
            <div class="inner">
              <div><h2>{props.title}</h2></div>
              <div><h3>{props.projectType}</h3></div>
            </div>
          </div>

          <div className="image-holder">
            <picture>
              <source 
                media="(max-width: 699px)" 
                srcset={imageUrlFor(buildImageObj(props.image.mobileImage))
                  .width(1000)
                  .height(Math.floor((1 / 1) * 1000))
                  .auto('format')
                  .url()}
              />
              <source 
                media="(min-width: 700px)" 
                srcset={imageUrlFor(buildImageObj(props.image.desktopImage))
                  .width(2000)
                  .height(Math.floor((1 / 2) * 2000))
                  .auto('format')
                  .url()}
              />
              <img
                src={imageUrlFor(buildImageObj(props.image.desktopImage))
                  .width(2000)
                  .height(Math.floor((1 / 2) * 2000))
                  .auto('format')
                  .url()}
                alt={props.image.desktopImage.alt}
                title={props.image.desktopImage.alt}
              />
            </picture>
          </div>
          </a>
          </div>
        )}
    </>
  )
}

export default ProjectPreview